var App = App || {};

App.ComponentSsFeatures = (function ($) {
    'use strict';

    function Init() {
        $(".component-ssFeatures").each(function () {
            const carousel = $(this).find(".component-ssFeatures-carousel");
            Carousel(carousel);
        });
    }

    function Carousel(carousel) {

        const drawing = carousel.find(".component-ssFeatures-drawing");
        const buttons = carousel.find(".component-ssFeatures-columns button");

        const splide = new Splide(carousel.find(".splide")[0], {
            type: "loop",
            perPage: 1
        });

        splide.on("mounted", function () {
            buttons.on("click", function () {
                const id = $(this).data("id");
                const slide = carousel.find(`.splide__slide:not(.splide__slide--clone)[data-id="${id}"]`);
                const index = splide.Components.Elements.slides.findIndex(s => s === slide.get(0));
                splide.go(index);
            });
        })

        splide.on("move", function (next) {

            const slide = $(splide.Components.Slides.getAt(next).slide);
            const id = slide.data("id");

            const image = drawing.find(`img[data-id="${id}"]`);
            image.fadeIn().siblings().fadeOut();

            buttons.toArray().forEach(button => {
                button.setAttribute("aria-selected", button.getAttribute("data-id") == id);
            });

        })
        
        splide.mount({});   
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentSsFeatures.Init();
});